<template>
  <div class='EnbStart'>
    <div class="cont">
      <div class="icon-rocket">
        <rocket-icon color="#FFFFFF"/>
      </div>
      <div class="text">DECOLE SEU NOGÓCIO NA INTERNET.</div>
      <div class="cont-form">
        <input-reg
        :value="payload.nome_empresa"
        text="Nome do negócio"
        @update:model-value="newValue => {
          payload.nome_empresa = newValue
          payload.subdominio = formatarTexto(newValue)
        }"
        :cont="{ width: '100%' }"
        :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
        :input="{ fontSize: '16px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
        :error="verify.nome_empresa.$invalid"
        />
        <div class="cont-sub">
          <input-reg
          :value="payload.subdominio"
          text="Link da estrutura"
          @update:model-value="newValue => payload.subdominio = formatarTexto(newValue)"
          :cont="{ width: '65%' }"
          :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
          :input="{ fontSize: '16px', padding: '2.5%', width: '94%', borderRadius: '5px' }"
          :error="verify.subdominio.$invalid"
          :errorMsg="verify.subdominio.has.$invalid ? verify.subdominio.has.$message : ''"
          />
          <div class="cont-dominio">
            .enobairro.com
          </div>
        </div>
        <input-select
        :value="payload.modelo"
        :data="models"
        text="Modelo"
        @update:model-value="newValue => payload.modelo = models.filter(m => m.name === newValue)[0].value"
        :cont="{ width: '97.5%', margin: 'auto' }"
        :label="{ textAlign: 'left', marginTop: '7px', marginLeft: '5px', fontSize: '12px' }"
        :input="{ width: '100%', padding: '2%', fontSize: '12px', borderRadius: '5px' }"
        :error="verify.modelo.$invalid"
        />
        <input-reg
        :value="payload.nome"
        text="Nome"
        @update:model-value="newValue => payload.nome = newValue"
        :cont="{ width: '100%' }"
        :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
        :input="{ fontSize: '16px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
        :error="verify.nome.$invalid"
        />
        <input-reg
        :value="payload.sobrenome"
        text="Sobrenome"
        @update:model-value="newValue => payload.sobrenome = newValue"
        :cont="{ width: '100%' }"
        :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
        :input="{ fontSize: '16px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
        :error="verify.sobrenome.$invalid"
        />
        <input-reg
        :value="payload.usuario"
        text="Usuário(Mínimo 4 caracteres)"
        @update:model-value="newValue => payload.usuario = newValue"
        :cont="{ width: '100%' }"
        :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
        :input="{ fontSize: '16px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
        :error="verify.usuario.$invalid"
        :errorMsg="verify.usuario.has.$invalid ? verify.usuario.has.$message : ''"
        />
        <input-reg
        :value="payload.email"
        text="Email"
        @update:model-value="newValue => payload.email = newValue"
        :cont="{ width: '100%' }"
        :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
        :input="{ fontSize: '16px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
        :error="verify.email.$invalid"
        :errorMsg="verify.email.has.$invalid ? verify.email.has.$message : ''"
        />
        <input-reg
        :value="payload.senha"
        text="Senha"
        @update:model-value="newValue => payload.senha = newValue"
        :cont="{ width: '100%' }"
        :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
        :input="{ fontSize: '16px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
        type="password"
        :error="verify.senha.$invalid"
        />
        <input-reg
        :value="payload.csenha"
        text="Confirmar senha"
        @update:model-value="newValue => payload.csenha = newValue"
        :cont="{ width: '100%' }"
        :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
        :input="{ fontSize: '16px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
        type="password"
        :error="verify.csenha.$invalid"
        />
        <vue-spinner v-if="load" size="30"/>
        <div style="padding: 3%;">{{ message }}</div>
        <button v-if="!load" @click="push">PRÓXIMO</button>
      </div>
      <div class="fundo"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import InputReg from '@/components/EnbPainel/Produtos/Register/InputReg'
import InputSelect from '@/components/EnbPainel/Produtos/Register/InputSelect'
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength, helpers } from '@vuelidate/validators'
import RocketIcon from '@/components/EnbPainel/Icons/RocketIcon'
import { VueSpinner } from 'vue3-spinners'
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  name: 'EnbStart',
  components: { InputReg, InputSelect, RocketIcon, VueSpinner },
  data () {
    return {
      load: false,
      message: '',
      models: [
        { value: 'Modelo 01', name: 'Loja Online' },
        { value: 'Modelo 03', name: 'Imóveis' }
      ],
      payload: {
        nome_empresa: "",
        subdominio: "",
        modelo: "",
        nome: "",
        sobrenome: "",
        usuario: "",
        email: "",
        senha: "",
        csenha: "",
        tipo: "a"
      },
      verify: {
        nome_empresa: { $invalid: false },
        subdominio: { $invalid: false, has: { $invalid: false, $message: '' } },
        modelo: { $invalid: false },
        nome: { $invalid: false },
        sobrenome: { $invalid: false },
        usuario: { $invalid: false, has: { $invalid: false, $message: '' } },
        email: { $invalid: false, has: { $invalid: false, $message: '' } },
        senha: { $invalid: false },
        csenha: { $invalid: false }
      }
    }
  },
  computed: {
    nome_empresa () {
      return this.payload.nome_empresa
    },
    subdominio () {
      return this.payload.subdominio
    },
    modelo () {
      return this.payload.modelo
    },
    nome () {
      return this.payload.nome
    },
    sobrenome () {
      return this.payload.sobrenome
    },
    usuario () {
      return this.payload.usuario
    },
    email () {
      return this.payload.email
    },
    senha () {
      return this.payload.senha
    },
    csenha () {
      return this.payload.csenha
    }
  },
  validations () {
    return {
      nome_empresa: {
        required
      },
      subdominio: {
        required,
        notPoint: (value) => value.indexOf('.') === -1,
        has: helpers.withMessage('Subdomínio não disponível', helpers.withAsync(this.subdominioHas))
      },
      modelo: {
        required
      },
      nome: {
        required
      },
      sobrenome: {
        required
      },
      usuario: {
        required,
        minLength: minLength(4),
        has: helpers.withMessage('Usuário não disponível', helpers.withAsync(this.userHas))
      },
      email: {
        required,
        email,
        has: helpers.withMessage('Email não disponível', helpers.withAsync(this.emailHas))
      },
      senha: {
        required,
        minLength: minLength(6)
      },
      csenha: {
        required,
        minLength: minLength(6),
        sameAs: (s) => s === this.senha
      },
    }
  },
  methods: {
    ...mapActions(['VerifyUserEmailHas', 'VerifySubdominioHas', 'createCompany']),
    formatarTexto(texto) {
      // Remove acentos e caracteres especiais
      let textoFormatado = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    
      // Remove todos os caracteres que não são letras, números ou espaços
      textoFormatado = textoFormatado.replace(/[^a-zA-Z0-9 ]/g, '')
    
      // Substitui espaços por traços
      textoFormatado = textoFormatado.replace(/\s+/g, '-')
    
      // Converte para minúsculas (opcional)
      textoFormatado = textoFormatado.toLowerCase()
    
      return textoFormatado
    },
    async push () {
      let valid = await this.v$.$validate()
      if(!valid) {
        this.verify = this.v$
        return
      }
      this.load = true
      this.createCompany(this.payload)
        .then(res => {
          if(!res.status) {
            this.load = false
            this.message = res.message
          }
          else {
            window.location.replace(`https://${this.payload.subdominio}.enobairro.com`)
            //window.location.replace(`http://${this.payload.subdominio}.localhost:8080`)
          }
        })
    },
    async userHas (str) { return await this.VerifyUserEmailHas({ user: str, email: str }).then(res => res.user) },
    async emailHas (str) { return await this.VerifyUserEmailHas({ user: str, email: str }).then(res => res.email) },
    async subdominioHas (str) { return await this.VerifySubdominioHas(str).then(res => res) }
  }
  // mounted ()  {
  //   let recaptchaScript = document.createElement('script')
  //   recaptchaScript.setAttribute('src', 'https://js.stripe.com/v3/buy-button.js')
  //   document.head.appendChild(recaptchaScript)
  // }
}
</script>

<style scoped>
.EnbStart {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background-color: #0e1e2b;
  overflow: auto;
  /* background-image: url('../assets/background.jpeg'); */
}

.cont {
  width: 30%;
  height: 100%;
}

.icon-rocket {
  padding-top: 5%;
}

.text {
  font-family: Poppins;
  width: 100%;
  padding-bottom: 5%;
  font-weight: 600;
  font-size: 35px;
  line-height: 36px;
  margin: auto;
  color: #FFFFFF;
  text-shadow: 
    -1px -1px 0 black, /* Contorno superior esquerdo */
    1px -1px 0 black,  /* Contorno superior direito */
    -1px 1px 0 black,  /* Contorno inferior esquerdo */
    1px 1px 0 black;
}

.cont-form {
  width: 96%;
  border-radius: 8px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 3px 0.05px #B3B3B3;
  padding: 5%;
}

button {
  border: 0;
  margin-top: 3%;
  padding: 3%;
  border-radius: 5px;
  background-color: #0e1e2b;
  color: #FFFFFF;
}

.fundo {
  width: 100%;
  height: 100px;
}

.cont-sub {
  display: flex;
  align-items: end;
  padding: 1.5%;
}

.cont-dominio {
  display: flex;
  padding: 2%;
  padding-left: 0;
  margin-left: 1%;
}

@media (max-width: 500px) {
  .cont {
    width: 90%;
  }
}
</style>
